// components/Footer.tsx
import React from "react";
import { FaInstagram, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="mt-6 border-t border-gray-200 bg-[#fff]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Left: Logo and description */}
                    <div>
                        <div className="flex items-center space-x-2">

                            <h2 className="text-lg font-poppins font-semibold text-[#242424]">
                              Bgremoverr.cloud
                            </h2>
                        </div>
                        <p className="mt-4 text-sm font-poppins text-[#242424] max-w-md">
                         Bgremoverr.cloud  is your all-in-one AI-powered tool for transforming images with ease. Instantly   <Link to="/" className="text-purple-600 hover:underline">
                                Remove backgrounds
                            </Link>{" "} with pixel-perfect accuracy or create eye-catching <span className="text-pink-500">❤️</span> by the team at{" "}
                            <Link to="/" className="text-purple-600 hover:underline">
                                Text Behind Image
                            </Link>{" "} designs — all directly in your browser, with no uploads or complexity.

                        </p>
                    </div>

                    {/* Right: Connect */}
                    <div>
                        <h3 className="text-sm font-semibold text-[#242424] mb-3 font-poppins ">CONNECT</h3>
                        <ul className="space-y-2">
                            <li className="flex items-center space-x-2 font-poppins ">
                                <FaInstagram className="text-[#242424]" />
                                <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-sm text-[#242424] hover:underline">
                                    Instagram
                                </a>
                            </li>
                            <li className="flex items-center space-x-2 font-poppins ">
                                <FaTwitter className="text-[#242424]" />
                                <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-sm text-[#242424] hover:underline">
                                    Twitter
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom: Copyright */}
                <div className="mt-10 pt-6 border-t font-poppins  border-gray-200 flex flex-col md:flex-row justify-between items-center text-sm text-[#242424]">
                    <p>© 2025  Bgremoverr.cloud . All rights reserved.</p>
                    <div className="flex space-x-4 mt-4 md:mt-0">
                        <Link to="/privacy-policy" className="hover:underline">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="hover:underline">
                            Terms of Service
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
